
import { required } from 'vuelidate/lib/validators'

export default {
  car: {
    tower_id: {
      required
    },
    unit_id: {
      required
    },
    plate: {
      required
    },
    model: {
      required
    },
    color: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/car/form/resources/validations.js